<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="i64"></a><a id="i197"></a><a id="i206"></a><a id="i428"></a><a id="i855"></a><a id="i871"></a><a id="i1133"></a><a id="VPS-1"></a><em class="italic">For my wife, Suzan, <br/>who has put up with a lot through the years <br/>from this scruffy old fighter pilot</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Ded.vue?13cf230e